// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"908":"eea626d4","937":"edfa0715"}[chunkId] + ".chunk.css";
};